import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconAutoRenders(props: SvgIconProps) {
  return (
    <SVGIcon width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
      <rect x="1.1665" y="1.16675" width="13.6667" height="13.6667" rx="0.5" stroke="#222222" />
      <path
        d="M15.0229 9L12.2587 6.2357C12.1285 6.10553 11.9174 6.10553 11.7872 6.2357L6.99996 11.023"
        stroke="#222222"
      />
      <circle cx="4.6665" cy="4.66675" r="2" stroke="#222222" />
      <path
        d="M1 12.3334L4.43096 8.90245C4.56114 8.77228 4.77219 8.77228 4.90237 8.90245L11 15.0001"
        stroke="#222222"
      />
    </SVGIcon>
  );
}
